export const APPROVAL_LEVELS = [
  { value: 1, label: "Level 1: <50K€" },
  { value: 2, label: "Level 2: 50K€-100K€" },
  { value: 3, label: "Level 3: >100K€" },
];

export const COUNTRY_FILTER_OPTIONS = [
  { value: "IT", label: "4100" },
  { value: "NOT_IT", label: "4N00" },
];
export const exportColumns = [
  { header: 'Billing Date', key: 'billingDate', width: 14,
    formatter: (row) => {
      if (!row.billingDate) return '';
      const [year, month, day] = row.billingDate.split('-');
      return `${day}-${month}-${year}`;
    }
  },
  { header: 'Dealer Number', key: 'dealerNumber', width: 16,
    formatter: (row) =>
      row.isSapNumberUploaded && row.sapNumber && row.source === 'UPLOAD'
        ? row.sapNumber
        : (row.dealerNumber || '')
  },
  { header: 'Dealer Country',     key: 'taxDestinationCountry', width: 16 },
  { header: 'Material',           key: 'material',              width: 14 },
  { header: 'Total Amount',       key: 'totalAmount',           width: 14,
    formatter: (row) => (row.totalAmount != null ? Number(row.totalAmount) : '')
  },
  { header: 'Currency',           key: 'currencydisplay',       width: 12 },
  { header: 'Item Text',          key: 'itemText',              width: 50 },
  { header: 'Request Number',     key: 'requestNumber',         width: 18 },
  { header: 'Invoice Number',     key: 'invoiceNumber',         width: 18 },
  { header: 'Account Number',     key: 'accountNumber',         width: 18 },
  { header: 'Type',               key: 'transactionType',       width: 12 },
  { header: 'Accounting User',    key: 'accountingUserId',      width: 20,
    formatter: (row) =>
      (!row.accountingUserId || row.accountingStatus === 'NOT_APPLICABLE') ? '-' : row.accountingUserId
  },
  { header: 'Accounting Status',  key: 'accountingStatus',      width: 18 },
  { header: 'Reason of Rejection', key: 'reasonOfRejection',      width: 30,
    formatter: (row) => row.reasonOfRejection || ''
  },
  { header: 'Approval Timestamp', key: 'accountingApprovalTimestamp', width: 22,
    formatter: (row) => {
      if (row.accountingStatus === 'NOT_APPLICABLE' || !row.accountingApprovalTimestamp) return '-';
      const d = new Date(row.accountingApprovalTimestamp);
      return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
    }
  },
];